// src/services/reportService.js
// Couche service — signalement de profils

import { db } from '../firebase';
import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  doc,
  updateDoc,
  orderBy,
  serverTimestamp,
} from 'firebase/firestore';

const reportService = {
  // ── Créer un signalement ─────────────────────────────
  async createReport(reporterId, reportedId, reason, comment = '') {
    try {
      // Vérifier doublon (même reporter + même reported)
      const q = query(
        collection(db, 'reports'),
        where('reporterId', '==', reporterId),
        where('reportedId', '==', reportedId)
      );
      const snap = await getDocs(q);
      if (!snap.empty) {
        return { success: false, error: 'already_reported' };
      }

      await addDoc(collection(db, 'reports'), {
        reporterId,
        reportedId,
        reason,
        comment: comment.slice(0, 500),
        status: 'pending',
        createdAt: serverTimestamp(),
      });

      return { success: true };
    } catch (err) {
      console.error('reportService.createReport error:', err);
      return { success: false, error: err.message };
    }
  },

  // ── Créer un signalement d'annonce ──────────────────
  async createAnnonceReport(reporterId, annonceId, authorId, reason, comment = '') {
    try {
      // Vérifier doublon (même reporter + même annonce)
      const q = query(
        collection(db, 'reports'),
        where('reporterId', '==', reporterId),
        where('annonceId', '==', annonceId)
      );
      const snap = await getDocs(q);
      if (!snap.empty) {
        return { success: false, error: 'already_reported' };
      }

      await addDoc(collection(db, 'reports'), {
        reporterId,
        reportedId: authorId,
        annonceId,
        type: 'annonce',
        reason,
        comment: comment.slice(0, 500),
        status: 'pending',
        createdAt: serverTimestamp(),
      });

      return { success: true };
    } catch (err) {
      console.error('reportService.createAnnonceReport error:', err);
      return { success: false, error: err.message };
    }
  },

  // ── Admin : lister les signalements ─────────────────
  async getReports(status = 'pending') {
    try {
      const q = query(
        collection(db, 'reports'),
        where('status', '==', status),
        orderBy('createdAt', 'desc')
      );
      const snap = await getDocs(q);
      return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    } catch (err) {
      console.error('reportService.getReports error:', err);
      return [];
    }
  },

  // ── Admin : résoudre un signalement ─────────────────
  async resolveReport(reportId, resolution) {
    try {
      await updateDoc(doc(db, 'reports', reportId), {
        status: resolution,
        resolvedAt: serverTimestamp(),
      });
      return { success: true };
    } catch (err) {
      console.error('reportService.resolveReport error:', err);
      return { success: false, error: err.message };
    }
  },

  // ── Admin : statistiques ────────────────────────────
  async getStats() {
    try {
      const [usersSnap, reportsSnap] = await Promise.all([
        getDocs(collection(db, 'users')),
        getDocs(collection(db, 'reports')),
      ]);
      const reports = reportsSnap.docs.map((d) => d.data());
      return {
        totalUsers: usersSnap.size,
        totalReports: reports.length,
        pendingReports: reports.filter((r) => r.status === 'pending').length,
      };
    } catch (err) {
      console.error('reportService.getStats error:', err);
      return { totalUsers: 0, totalReports: 0, pendingReports: 0 };
    }
  },
};

export default reportService;
